import PropTypes from 'prop-types';
import Text from 'ol/style/Text';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';

/**
 * Default text style for features.
 *
 * @component
 */
export function defaultText(_ref) {
  var labelProperty = _ref.labelProperty,
    minResolution = _ref.minResolution,
    maxResolution = _ref.maxResolution,
    textTransform = _ref.textTransform,
    font = _ref.font,
    color = _ref.color,
    strokeColor = _ref.strokeColor,
    offsetX = _ref.offsetX,
    offsetY = _ref.offsetY,
    backgroundFillColor = _ref.backgroundFillColor,
    textAlign = _ref.textAlign,
    padding = _ref.padding,
    rotation = _ref.rotation;
  return function (feature, resolution) {
    if (resolution < minResolution || resolution > maxResolution) return;
    var text = feature.get(labelProperty);
    if (!text) return;
    return new Text({
      text: (textTransform || function (t) {
        return t;
      })(text),
      fill: new Fill({
        color: color || 'rgb(255,255,255)'
      }),
      stroke: strokeColor && new Stroke({
        color: strokeColor
      }),
      offsetX: offsetX,
      offsetY: offsetY,
      backgroundFill: backgroundFillColor && new Fill({
        color: backgroundFillColor
      }),
      textAlign: textAlign,
      font: font || '10px sans-serif',
      padding: padding,
      rotation: rotation
    });
  };
}
defaultText.propTypes = {
  /** The feature property to get text from. */
  labelProperty: PropTypes.string,
  /** Minimum resolution where the label will be rendered. */
  minResolution: PropTypes.number,
  /** Maximum resolution where the label will be rendered. */
  maxResolution: PropTypes.number,
  /** Font. */
  font: PropTypes.string,
  /** Text color. */
  color: PropTypes.string,
  /** Text stroke color. */
  strokeColor: PropTypes.string,
  /** Text align. */
  textAlign: PropTypes.string,
  /** Text padding in pixels. */
  padding: PropTypes.arrayOf(PropTypes.number),
  /** Label horizontal offset in pixels. */
  offsetX: PropTypes.number,
  /** Label vertical offset in pixels (positive values offset downwards). */
  offsetY: PropTypes.number,
  /** Rotation in radians (positive rotation clockwise). */
  rotation: PropTypes.number,
  /** Color of background fill. */
  backgroundFillColor: PropTypes.string
};
export default defaultText;